import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const loadSocialUsersObjs = makePieActionObjs("load", "social_users")
export const loadSocialUserActionDict = loadSocialUsersObjs.pieDict

const actionTypes = {
    ...loadSocialUsersObjs.actionTypes,

    LOADED_SOCIAL_USERS: "LOADED_SOCIAL_USERS",
    VALIDATED_SOCIAL_USER: "VALIDATED_SOCIAL_USER",
    VALIDATED_SOCIAL_USER_ARRAY: "VALIDATED_SOCIAL_USER_ARRAY",
    ADDED_SOCIAL_USER: "ADDED_SOCIAL_USER",
    CUE_SOCIAL_USER_FOR_DELETION: "CUE_SOCIAL_USER_FOR_DELETION",
    DELETED_SOCIAL_USERS: "DELETED_SOCIAL_USERS",
    CLEAR_VALIDATED_SOCIAL_USERS: "CLEAR_VALIDATED_SOCIAL_USERS",
    PATCH_SOCIAL_USERS_START: `PATCH_SOCIAL_USERS_START`,
    PATCH_SOCIAL_USERS_SUCCESS: `PATCH_SOCIAL_USERS_SUCCESS`,
    PATCH_SOCIAL_USERS_FAIL: `PATCH_SOCIAL_USERS_FAIL`,
}

export const patchSocialUsersTypes = {
    start: actionTypes.PATCH_SOCIAL_USERS_START,
    success: actionTypes.PATCH_SOCIAL_USERS_SUCCESS,
    fail: actionTypes.PATCH_SOCIAL_USERS_FAIL
}

export default actionTypes
